import { StockStatus } from 'models/ProductMeta';
import { SaleStatus } from 'models/SaleStatus';
import styles from './styles.scss';
import cn from 'classnames';
import { IconCheckmark } from 'components/Shared/Icon';

interface StockProps {
  stockText: string;
  stockStatus: StockStatus;
  saleStatus: SaleStatus;
}

export const Stock = ({ stockText, stockStatus, saleStatus }: StockProps) => {
  const shouldHaveCheckmark =
    (stockStatus === StockStatus.Storage ||
      stockStatus === StockStatus.Create ||
      stockStatus === StockStatus.Order) &&
    saleStatus !== SaleStatus.NotInStock;

  const isDefiniteStock = [StockStatus.Storage, StockStatus.Order].includes(stockStatus);
  const isVaugeStock = stockStatus === StockStatus.Create || saleStatus === SaleStatus.NotInStock;

  return (
    <strong
      className={cn(styles.stockStatus, {
        [styles.definite]: isDefiniteStock,
        [styles.vague]: isVaugeStock
      })}
    >
      {shouldHaveCheckmark && <IconCheckmark className={styles.checkmark} />}
      {stockText}
    </strong>
  );
};
